import React from 'react'
import { Modal } from '@pushly/aqe/lib/components'
import { getClassNames } from '../../../_utils/classnames'
import { InfoCircleOutlined } from '@ant-design/icons'
import { Button } from '@pushly/aqe/lib/components'
import { ShareReportPanel } from '../report-builder/report-builder'
import { Space, Typography } from 'antd'

interface ISRAMProps {
    action: string
    visible: boolean
    onCancel: () => void
    onOk: (report: any) => Promise<void>
    report: any
    getAppContainer?: any
    confirmLoading?: boolean
}

interface ISRAMState {}

export const SavedReportsActionsModal: React.FC<React.PropsWithChildren<ISRAMProps>> = ({ ...props }: ISRAMProps) => {
    const { action, visible, onCancel, onOk, report, getAppContainer, confirmLoading } = props

    return (
        <Modal
            open={visible}
            className={getClassNames('saved-reports-actions-modal')}
            onCancel={onCancel}
            onOk={onOk}
            title={
                <span>
                    {action === 'Archive' && <InfoCircleOutlined style={{ color: '#faad14' }} />} {action} Report
                </span>
            }
            closable={true}
            getContainer={getAppContainer}
            confirmLoading={confirmLoading}
            footer={
                action === 'Archive' ? (
                    <Space>
                        <Button type="default" size="middle" onClick={onCancel}>
                            <span>Cancel</span>
                        </Button>
                        <Button size="middle" type="primary" onClick={() => onOk(report)}>
                            <span>Archive</span>
                        </Button>
                    </Space>
                ) : null
            }
        >
            <div>
                {action === 'Share' && (
                    <ShareReportPanel key={String(visible)} reportConfig={report.reportConfig} visible={visible} />
                )}
            </div>

            <div>
                {action === 'Archive' && (
                    <div className={getClassNames('archive-report-inner')}>
                        <div className={getClassNames('archive-display-upper')}>
                            <Typography.Paragraph>
                                Are you sure you want to archive the following report?
                            </Typography.Paragraph>
                            <Typography.Paragraph strong>{report.name}</Typography.Paragraph>
                            <Typography.Paragraph>
                                This report will no longer be available in your saved reports list and will need to be
                                manually generated.
                            </Typography.Paragraph>
                        </div>
                    </div>
                )}
            </div>
        </Modal>
    )
}
